import { get as _get } from 'lodash';

import { ServiceLocatorActions, ServiceLocatorActionTypes } from './service-locator.actions';
import { DrpLocatorState, initialServiceLocatorState } from './service-locator.models';

export function reducer(
  state = initialServiceLocatorState,
  action: ServiceLocatorActions
): DrpLocatorState {
  switch (action.type) {
    case ServiceLocatorActionTypes.SERVICE_SEARCH_INIT:
      return Object.assign({}, initialServiceLocatorState, {
        searchContext: _get(action, 'payload.searchContext')
      });

    case ServiceLocatorActionTypes.SERVICE_SEARCH:
      return Object.assign({}, state, {
        loading: true,
        searchedValue: _get(action, 'payload')
      });
    case ServiceLocatorActionTypes.SERVICE_SEARCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        searchResults: _get(action, 'payload')
      });
    case ServiceLocatorActionTypes.SERVICE_SEARCH_FAIL:
      return Object.assign({}, state, {
        loading: false,
        searchResults: [],
        error: _get(action, 'payload')
      });
    case ServiceLocatorActionTypes.SET_LAST_SUCCESSFUL_SEARCHED_VALUE:
      return Object.assign({}, state, {
        lastSuccessfulSearchValue: _get(action, 'payload')
      });
    case ServiceLocatorActionTypes.SERVICE_SEARCH_BY_CHANGED:
      return Object.assign({}, state, {
        searchResults: []
      });
    default:
      return state;
  }
}

export const isLoading = (state: DrpLocatorState) => state.loading;
export const getSearchContext = (state: DrpLocatorState) => state.searchContext;
export const getSearchResults = (state: DrpLocatorState) => state.searchResults;
export const getSearchedValue = (state: DrpLocatorState) => state.searchedValue;
export const getLastSuccessfulSearchValue = (state: DrpLocatorState) =>
  state.lastSuccessfulSearchValue;
export const getError = (state: DrpLocatorState) => state.error;
